import React from "react";
import "./styles.less";

export const BlogNoData = () => {
  return (
    <div className="blog-no-data">
      <img width="155px" src="//files.authing.co/authing-blog/no-data.png" alt="Please wait" />
      <div
        style={{
          color: "#666",
          marginTop: 30,
        }}
      >
        暂无内容
      </div>
    </div>
  );
};
